var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeinture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_573_4140)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_573_4140",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4906 3.83636H11.0793C9.33339 3.83636 7.91357 5.25618 7.91357 7.00206V11.7506C7.91357 13.4965 9.33339 14.9163 11.0793 14.9163H28.4906C30.2365 14.9163 31.6563 13.4965 31.6563 11.7506V7.00206C31.6563 5.25618 30.2365 3.83636 28.4906 3.83636ZM11.0793 11.7506V7.00206H28.4906L28.4938 11.7506H11.0793Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.4906 3.83636H11.0793C9.33339 3.83636 7.91357 5.25618 7.91357 7.00206V11.7506C7.91357 13.4965 9.33339 14.9163 11.0793 14.9163H28.4906C30.2365 14.9163 31.6563 13.4965 31.6563 11.7506V7.00206C31.6563 5.25618 30.2365 3.83636 28.4906 3.83636ZM11.0793 11.7506V7.00206H28.4906L28.4938 11.7506H11.0793Z",
    fill: "#A3AED0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0793 11.7506H3.08172V19.7482H11.0793V11.7506ZM11.0793 7.00206V-0.995491H3.08172V7.00206H11.0793ZM28.4906 7.00206L36.4882 6.99673L36.4828 -0.995491H28.4906V7.00206ZM28.4938 11.7506V19.7482H36.4967L36.4913 11.7453L28.4938 11.7506ZM28.4906 -4.16119H11.0793V11.8339H28.4906V-4.16119ZM11.0793 -4.16119C4.91646 -4.16119 -0.083981 0.839253 -0.083981 7.00206H15.9111C15.9111 9.67311 13.7503 11.8339 11.0793 11.8339V-4.16119ZM-0.083981 7.00206V11.7506H15.9111V7.00206H-0.083981ZM-0.083981 11.7506C-0.083981 17.9134 4.91646 22.9139 11.0793 22.9139V6.91876C13.7503 6.91876 15.9111 9.07957 15.9111 11.7506H-0.083981ZM11.0793 22.9139H28.4906V6.91876H11.0793V22.9139ZM28.4906 22.9139C34.6534 22.9139 39.6539 17.9134 39.6539 11.7506H23.6588C23.6588 9.07957 25.8196 6.91876 28.4906 6.91876V22.9139ZM39.6539 11.7506V7.00206H23.6588V11.7506H39.6539ZM39.6539 7.00206C39.6539 0.839256 34.6534 -4.16119 28.4906 -4.16119V11.8339C25.8196 11.8339 23.6588 9.67311 23.6588 7.00206H39.6539ZM19.0768 11.7506V7.00206H3.08172V11.7506H19.0768ZM11.0793 14.9996H28.4906V-0.995491H11.0793V14.9996ZM20.4931 7.0074L20.4962 11.7559L36.4913 11.7453L36.4882 6.99673L20.4931 7.0074ZM28.4938 3.75306H11.0793V19.7482H28.4938V3.75306Z",
    fill: "#A3AED0",
    mask: "url(#path-1-inside-1_573_4140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5764 24.4134V21.2477C20.5764 19.5018 19.1566 18.082 17.4107 18.082H6.33074V8.5849C4.58486 8.5849 3.16504 10.0047 3.16504 11.7506V18.082C3.16504 19.8279 4.58486 21.2477 6.33074 21.2477H17.4107V24.4134C16.9909 24.4134 16.5883 24.5802 16.2914 24.877C15.9946 25.1738 15.8278 25.5764 15.8278 25.9962V33.9105C15.8278 34.3303 15.9946 34.7329 16.2914 35.0297C16.5883 35.3266 16.9909 35.4933 17.4107 35.4933H20.5764C20.9962 35.4933 21.3988 35.3266 21.6956 35.0297C21.9925 34.7329 22.1592 34.3303 22.1592 33.9105V25.9962C22.1592 25.5764 21.9925 25.1738 21.6956 24.877C21.3988 24.5802 20.9962 24.4134 20.5764 24.4134Z",
    fill: "#A3AED0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0186 24.9768H27.4872M10.893 24.9768C9.71939 24.9768 8.59385 25.2577 7.76398 25.7576C6.93411 26.2576 6.46789 26.9356 6.46789 27.6427V40.9719C6.46789 41.6789 6.93411 42.357 7.76398 42.857C8.59385 43.3569 9.71939 43.6378 10.893 43.6378H37.4437",
    stroke: "#A3AED0",
    strokeWidth: 2.66585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4439 43.6377C35 43.6377 33.0188 42.4442 33.0188 40.9719C33.0188 39.4996 35 38.306 37.4439 38.306C39.8878 38.306 41.869 39.4996 41.869 40.9719C41.869 42.4442 39.8878 43.6377 37.4439 43.6377Z",
    stroke: "#A3AED0",
    strokeWidth: 2.66585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0188 40.9718V24.9767C33.0188 24.2697 33.485 23.5916 34.3149 23.0917C35.1447 22.5917 36.2703 22.3109 37.4439 22.3109C38.6175 22.3109 39.7431 22.5917 40.5729 23.0917C41.4028 23.5916 41.869 24.2697 41.869 24.9767V40.9718",
    stroke: "#A3AED0",
    strokeWidth: 2.66585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_573_4140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(-0.000610352 0.670532)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeinture);
export default __webpack_public_path__ + "static/media/Peinture.654af969679438cc0e6796ffc0e13834.svg";
export { ForwardRef as ReactComponent };